import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { UserRouteAccessService } from './auth/user-route-access-service';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { UrlSecurityGuard } from './url-security.guard';
import { MaintenanceGuard } from './shared/guard/maintenance.guard';
import { MaintenancePageComponent } from './maintenance-page/maintenance-page.component';
import { CustomRouteReuseStrategy } from './core/custom-route-reuse-strategy';
import { CPQResponderComponent } from './cpq-responder/cpq-responder.component';

const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    canActivate: [MaintenanceGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: 'client/:clientName',
    component: LoginLayoutComponent,
    canActivate: [MaintenanceGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '',
    canActivate: [UserRouteAccessService, UrlSecurityGuard, MaintenanceGuard],
    // canActivateChild: [MaintenanceGuard],
    loadChildren: () =>
      import('./layouts/main-layout/main-layout.module').then(
        (m) => m.MainLayoutModule
      ),
  },
  { path: 'maintenance', component: MaintenancePageComponent },
  { path: 'cpq-responder', component: CPQResponderComponent },
  { path: '**', redirectTo: 'proposals/events' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      relativeLinkResolution: 'legacy',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],
})
export class AppRoutingModule {}
